import util from '@bmp-vue/core/api/util'
import Vue from 'vue'

const controller = 'Documento'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  GetFile (model, file) {
    util.Functions.FileToByteArray(file, function (data) {
      model.Arquivo = data
      var arquivo = (file.name).split('.')
      model.Extensao = arquivo.at(-1)
      Vue.set(model, 'NomeArquivo', arquivo.slice(0, -1).join('.'))
    })
  }
})
